module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAALCAYAAABPhbxiAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAECSURBVCiRlZCxTsJQGEbPvdbBd3Bh5C06Mrg01NHEgeTG3JB0aFgdcKa31qS0q67E+AQy8BA8AEMHRxIJueU6CIRUMfiNX875/uQXJivfwfn8K2LqbaUJ8Bn11c1fuMmKZ+ACXFcCnEt7C65lnsrhMSnJigdwrW8WJIDWermWdYhzYZIWvR9SWvQEdNeyDrXWy70IMNC6shAIyXCUjju7fpSOO0JybyEYaF3teu9wOe6ruTHFtfTEa/pYTpHgcD6WII7U/JCVNBJFamZXtJ3YvNUwsSvaUaRmTc5rFgBxrD6Al2OP+vXiqZECqiTJ/VOFLbsQxuRXnMkcuDzRXVBv7r4A9mhamuUH0RkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/infomsgicon2.png
// module id = VEyR
// module chunks = 1